export default __webpack_public_path__ + "static/media/gallery_06.47e771b9.jpg";